import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Subject } from "rxjs";
import { DescrittoreSezione } from "../common/models/descrittore-sezione";
import { inject } from "@angular/core";
import { HelpersService } from "../core/services/helpers.service";
import { UrlSettingsCore } from "../core/configuration/url-settings-core";
import { ModalNotifyService } from "../core/services/modal-notify.service";
import { ConfigurationService } from "../common/configuration/services/configuration.service";
import { ConfigurationFeature } from "../common/configuration/models/configuration";

export const authGuardGestioneDocumenti = (next: ActivatedRouteSnapshot) => {
  const helpersService: HelpersService = inject(HelpersService);
  const modalNotifyService: ModalNotifyService= inject(ModalNotifyService);
  const router: Router = inject(Router);
  const configService: ConfigurationService = inject(ConfigurationService)

  if (configService.isFeatureEnabled(ConfigurationFeature.DOCUMENT_INGESTION)) {
    let subject = new Subject<boolean>();
    helpersService.getDescrittori().subscribe(res => {
      return subject.next(checkDescrittori(res, next, modalNotifyService, router))
    });

    return subject.asObservable();
  } else {
    allertMessage(false, modalNotifyService, router);
  }

}

const checkDescrittori = (descrittori: DescrittoreSezione[], route: ActivatedRouteSnapshot, modalNotifyService: ModalNotifyService, router: Router) => {
   let checkDescrittore: boolean = false;

  //controllo prima il descrittore associato alla route
  if (route.data && route.data.descrittore) {
    let descrittore = route.data.descrittore;
    let descrittoreUser = descrittori.find(el => el.entitySimpleName === descrittore);
    if (descrittoreUser && (descrittoreUser.readable || descrittoreUser.writable)) {
      checkDescrittore = true;
    } else {
      allertMessage(false, modalNotifyService, router);
      return checkDescrittore = false;
    }
  } else checkDescrittore = true;
  return checkDescrittore;
}

const allertMessage = (permesso: boolean, modalNotifyService: ModalNotifyService, router: Router) => {
  if (!permesso) {
    modalNotifyService.messaggioCustom('Permesso negato', 'Attenzione!');
    router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
  }
}
